import { render, staticRenderFns } from "./ThirdShow.vue?vue&type=template&id=a8ba05e0&scoped=true"
import script from "./ThirdShow.vue?vue&type=script&lang=js"
export * from "./ThirdShow.vue?vue&type=script&lang=js"
import style0 from "./ThirdShow.vue?vue&type=style&index=0&id=a8ba05e0&prod&lang=less&scoped=true"
import style1 from "./ThirdShow.vue?vue&type=style&index=1&id=a8ba05e0&prod&scoped=true&lang=css"
import style2 from "./ThirdShow.vue?vue&type=style&index=2&id=a8ba05e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ba05e0",
  null
  
)

export default component.exports